
<template>
  <div />
  <!--
  <router-link :to="url"
               target="_blank">数据大屏</router-link>
               -->
</template>

<script>
export default {
  created() {
    const c = this.$router.resolve({
      path: '/zzf-board',
      query: { id: 1 }
    })
    window.open(c.href, '_blank')
    this.$router.go(-1)
  },
  data() {
    return {
      url: '/zzf-board'
    }
  }
}
</script>
